<template>
  <div :class="wrapperClasses">
    <slot v-if="fullSize" />
    <div
      v-else
      class="relative w-full max-h-full overflow-auto scrolling-touch"
    >
	    <div class="my-8 px-4">
        <div class="mb-7 last:mb-0">
          <Heading
            v-if="headingText"
            :class="`mb-4 last:mb-0 ${headingColorClass || ''} text-center`"
            large
            :text="headingText"
          />
          <Subheading
            v-if="subheadingText"
            :class="`mb-4 last:mb-0 ${subheadingColorClass || ''} text-center`"
            :text="subheadingText"
          />
        </div>
		    <slot />
	    </div>
    </div>
  </div>
</template>

<script>
import Heading from '@/components/text/Heading.vue'
import Subheading from '@/components/text/Subheading.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'Layout',

  props: {
    colorClasses: {
      type: String,
      default: ''
    },
    fullSize: {
      type: Boolean,
      default: false
    },
    headingText: {
      type: String,
      default: ''
    },
    subheadingText: {
      type: String,
      default: ''
    },
  },

  components: {
    Heading,
    Subheading
  },

  computed: {
    // Store
    ...mapGetters([ 'myStore' ]),
    // Styles
    globalStyles() { return this.myStore(['styles', 'global']) },
    // Container
    pageStyles() { return this.globalStyles.page ?? {} },
    wrapperClasses() {
      const bgClass = `bg-${this.pageStyles.bg_color || 'off-white'}`
      const textClass = `text-${this.pageStyles.text_color || 'body'}`
      return [
        'LayoutComp',
        'a-cover overflow-hidden',
        'flex justify-center items-center',
        this.colorClasses || `${bgClass} ${textClass}`,
      ]
    },
    // Heading
    headingStyles() { return this.globalStyles.heading ?? {} },
    headingColorClass() { return this.headingStyles.text_color && `text-${this.headingStyles.text_color}` },
    // Subheading
    subheadingStyles() { return this.globalStyles.subheading ?? {} },
    subheadingColorClass() { return this.subheadingStyles.text_color && `text-${this.subheadingStyles.text_color}` },
  }
}

</script>

